/**
 * Converts a local Date to YYYYMMDD string format without UTC conversion.
 * Uses local date components (year, month, day) directly.
 *
 * @param d - The Date object to format
 * @returns A string in YYYYMMDD format (e.g., "20240115")
 *
 * @example
 * const date = new Date(2024, 0, 15); // Jan 15, 2024
 * toLocalYYYYMMDD(date); // "20240115"
 */
export function toLocalYYYYMMDD(d: Date): string {
  return `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, "0")}${String(
    d.getDate()
  ).padStart(2, "0")}`;
}
